import { api } from '../../../api/api';

const LIVESTREAMING_TAG = 'livestreaming';

export interface SetupCameraRequest {
  sim_number: string;
  ports: number[];
}

export interface ConfigureRtspRequest {
  camera_id: string;
  rtsp_port: number;
  rtsp_path: string;
  duration: number;
  include_audio: boolean;
  is_active: boolean;
  schedule: string;
}

export interface RtspNowRequest {
  camera_id: string;
  rtsp_port: number;
  rtsp_path: string;
  duration: number;
  include_audio: boolean;
}

export interface ShareCodeRequest {
  camera_id: string;
  email_address: string;
  html_code: string;
}

export interface LivestreamingApiResponse {
  success: boolean;
  data?: any;
  message?: string;
  details?: string;
}

export const livestreamingApi = api.enhanceEndpoints({ addTagTypes: [LIVESTREAMING_TAG] }).injectEndpoints({
  endpoints: (build) => ({
    setupCamera: build.mutation<LivestreamingApiResponse, SetupCameraRequest>({
      query: (data) => ({
        method: 'POST',
        url: '/livestreaming/setup-camera',
        body: data
      }),
      invalidatesTags: [LIVESTREAMING_TAG]
    }),
    configureRtsp: build.mutation<LivestreamingApiResponse, ConfigureRtspRequest>({
      query: (data) => ({
        method: 'POST',
        url: '/livestreaming/configure-rtsp',
        body: data
      }),
      invalidatesTags: [LIVESTREAMING_TAG]
    }),
    rtspNow: build.mutation<LivestreamingApiResponse, RtspNowRequest>({
      query: (data) => ({
        method: 'POST',
        url: '/livestreaming/rtsp-now',
        body: data
      }),
      invalidatesTags: [LIVESTREAMING_TAG]
    }),
    shareCode: build.mutation<LivestreamingApiResponse, ShareCodeRequest>({
      query: (data) => ({
        method: 'POST',
        url: '/livestreaming/share-code',
        body: data
      })
    })
  })
});

export const {
  useSetupCameraMutation,
  useConfigureRtspMutation,
  useRtspNowMutation,
  useShareCodeMutation
} = livestreamingApi;
